import { forwardRef } from 'react';
import './Toggle.css';

const Toggle = forwardRef(({
  checked,
  onCheckedChange,
  label,
  disabled = false,
  className = '',
  ...props
}, ref) => {
  if (!label) {
    throw new Error('Toggle requires a non-empty label for its accessible name.');
  }

  return (
    <button
      ref={ref}
      type="button"
      role="switch"
      aria-checked={Boolean(checked)}
      aria-label={label}
      className={`rds-toggle rds-focusable ${className}`.trim()}
      data-state={checked ? 'checked' : 'unchecked'}
      disabled={disabled}
      onClick={() => onCheckedChange?.(!checked)}
      {...props}
    >
      <span className="rds-toggle__thumb" aria-hidden="true" />
    </button>
  );
});

Toggle.displayName = 'Toggle';

export default Toggle;
